// @flow
import React from 'react';
import { Portal } from 'react-portal';
import { VictoryTooltip } from 'victory';

import type { Vis } from '../../constants';
import TooltipContainer from '../GenericTooltip';
import { getCityNameWithState } from '../../utils/format';

type Props = {
  x: number,
  y: number,
  active: boolean,
  datum: any,
  visType: Vis,
  width: number,
  height: number,
  node: Node,
};

export default class PortalTooltip extends React.Component<Props> {
  static defaultEvents = VictoryTooltip.defaultEvents;
  static defaultProps = VictoryTooltip.defaultProps;

  render() {
    const { x, y, active, datum, visType, width, height, node } = this.props;

    if (!active) return null;

    return (
      <Portal node={node}>
        <TooltipContainer
          title={getCityNameWithState(datum.name, datum.state)}
          x={x}
          y={y}
          visType={visType}
          mainValue={datum.y}
          sideColor={datum.color}
          timestamp={datum.x}
          bounds={{ padding: 10, width, height }}
        />
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LineChart/PortalTooltip.jsx